module.exports = __webpack_public_path__ + "static/img/AU.949b3b4b.jpg";